/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { RoadsDto } from '../../models/roads-dto';

export interface GetRoadsById$Params {
  roadId: number;
}

export function getRoadsById(
  http: HttpClient,
  rootUrl: string,
  params: GetRoadsById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RoadsDto>> {
  const rb = new RequestBuilder(rootUrl, getRoadsById.PATH, 'get');
  if (params) {
    rb.path('roadId', params.roadId, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RoadsDto>;
      }),
    );
}

getRoadsById.PATH = '/roads/{roadId}';
